import { Map } from 'immutable';

import bankFilterOptions from '../../constants/bankFilterOptions';
import accountTypeFilterOptions from '../../constants/accountStatusFilterOptions';

export default Map({
  bank: bankFilterOptions[0],
  accountStatus: accountTypeFilterOptions[0],
});
